/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SravniMicroErrorsError {
  code?: string | null;
  target?: string | null;
  message?: string | null;
  attemptedValue?: string | null;
  details?: SravniMicroErrorsError[] | null;
}

export interface SravniMicroErrorsErrorModel {
  error?: SravniMicroErrorsError;
}

export interface SravniReviewsAttachmentsAttachmentWithContentModel {
  /** @format uuid */
  id?: string;

  /** @format date-time */
  created?: string;
  name?: string | null;
  extension?: string | null;
  url?: string | null;
  path?: string | null;

  /** @format byte */
  content?: string | null;
}

export interface SravniReviewsDdlItem {
  key?: string | null;
  value?: string | null;
}

export enum SravniReviewsEnumsActivityEventType {
  None = 'none',
  ReviewAdded = 'reviewAdded',
  ReviewEdited = 'reviewEdited',
  ReviewDeleted = 'reviewDeleted',
  ReviewChecked = 'reviewChecked',
  CommentAdded = 'commentAdded',
  CommentEdited = 'commentEdited',
  CommentDeleted = 'commentDeleted',
  CommentChecked = 'commentChecked',
  RatingAccepted = 'ratingAccepted',
  RatingChanged = 'ratingChanged',
  RatingRejected = 'ratingRejected',
  ProblemSolved = 'problemSolved',
  ReviewFollowUp = 'reviewFollowUp',
  DocumentsRequested = 'documentsRequested',
  DocumentsRecieved = 'documentsRecieved',
  DocumentsRemoved = 'documentsRemoved',
  DocumentsRequestCancelled = 'documentsRequestCancelled',
  DocumentsApproved = 'documentsApproved',
  DocumentsFailed = 'documentsFailed',
  ReviewRestored = 'reviewRestored',
  CommentRestored = 'commentRestored',
  ProblemSolutionReset = 'problemSolutionReset',
  ReviewUnchecked = 'reviewUnchecked',
  CommentUnchecked = 'commentUnchecked',
  ReviewObjectTypeChanged = 'reviewObjectTypeChanged',
  ReviewPreModerationApproved = 'reviewPreModerationApproved',
  CommentPreModerationApproved = 'commentPreModerationApproved',
  ReviewTagAdded = 'reviewTagAdded',
  ReviewTagRemoved = 'reviewTagRemoved',
  ReviewTagChanged = 'reviewTagChanged',
  DocumentsChanged = 'documentsChanged',
  AutomaticCommentDeleted = 'automaticCommentDeleted',
  DocumentsRequestedAgain = 'documentsRequestedAgain',
}

export enum SravniReviewsEnumsDateInterval {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

export enum SravniReviewsEnumsExternalApiActivityEventType {
  ReviewEdited = 'reviewEdited',
  ReviewChecked = 'reviewChecked',
  CommentAdded = 'commentAdded',
  CommentEdited = 'commentEdited',
  RatingAccepted = 'ratingAccepted',
  RatingChanged = 'ratingChanged',
  RatingRejected = 'ratingRejected',
  ProblemSolved = 'problemSolved',
  ProblemSolutionReset = 'problemSolutionReset',
}

export enum SravniReviewsEnumsModerationReasonType {
  None = 'none',
  EmailContent = 'emailContent',
  PhoneContent = 'phoneContent',
  AbusiveContent = 'abusiveContent',
  Ads = 'ads',
  Spam = 'spam',
  Fraud = 'fraud',
  IncompleteData = 'incompleteData',
  ImageContent = 'imageContent',
  Link = 'link',
  TransliterationContent = 'transliterationContent',
  UnreadableContent = 'unreadableContent',
  ImportedRequiresConfirmation = 'importedRequiresConfirmation',
  InvalidContentMatching = 'invalidContentMatching',
  Duplicate = 'duplicate',
  RequestAReviewSupplement = 'requestAReviewSupplement',
}

export enum SravniReviewsEnumsOrganizationType {
  Unknown = 'unknown',
  Bank = 'bank',
  Insurance = 'insurance',
  Mfo = 'mfo',
  EducationalOrganization = 'educationalOrganization',
  Broker = 'broker',
  Npf = 'npf',
  Leasing = 'leasing',
  Marketplace = 'marketplace',
  Bankruptcy = 'bankruptcy',
  University = 'university',
  Bookmaker = 'bookmaker',
}

export enum SravniReviewsEnumsRatingType {
  Default = 'default',
  OrganizationOnly = 'organizationOnly',
  ServiceTag = 'serviceTag',
  Locations = 'locations',
  Filters = 'filters',
}

/**
 * Список полей для csv
 */
export enum SravniReviewsEnumsReputationDetailField {
  From = 'from',
  To = 'to',
  ReviewsCount = 'reviewsCount',
  ApprovedCount = 'approvedCount',
  RejectedCount = 'rejectedCount',
  AvgRatingValue = 'avgRatingValue',
  AnswersCount = 'answersCount',
  ResolvedCount = 'resolvedCount',
  AvgResponseTime = 'avgResponseTime',
  AvgResolvedTime = 'avgResolvedTime',
  PositiveVotesCount = 'positiveVotesCount',
  NegativeVotesCount = 'negativeVotesCount',
  ZeroRatingApprovedReviewsCount = 'zeroRatingApprovedReviewsCount',
  OneRatingApprovedReviewsCount = 'oneRatingApprovedReviewsCount',
  TwoRatingApprovedReviewsCount = 'twoRatingApprovedReviewsCount',
  ThreeRatingApprovedReviewsCount = 'threeRatingApprovedReviewsCount',
  FourRatingApprovedReviewsCount = 'fourRatingApprovedReviewsCount',
  FiveRatingApprovedReviewsCount = 'fiveRatingApprovedReviewsCount',
}

export enum SravniReviewsEnumsReputationGroupingType {
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Years = 'years',
}

export enum SravniReviewsEnumsReviewAuthorRoleType {
  All = 'all',
  Users = 'users',
  Moderators = 'moderators',
  Representatives = 'representatives',
}

/**
 * Тип фильтрации отзывов
 */
export enum SravniReviewsEnumsReviewFilter {
  WithAnswers = 'withAnswers',
  WithRates = 'withRates',
  Resolved = 'resolved',
  RatesRejected = 'ratesRejected',
  All = 'all',
}

/**
* Типы объектов для которых можно добавлять комментарии.
Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
Поэтому добавляя/изменяя значения синхронизируйте их с базой.
*/
export enum SravniReviewsEnumsReviewObjectType {
  Unknown = 'unknown',
  Banks = 'banks',
  InsuranceCompany = 'insuranceCompany',
  CarService = 'carService',
  CarModel = 'carModel',
  Mfi = 'mfi',
  EducationalOrganization = 'educationalOrganization',
  Broker = 'broker',
  Npf = 'npf',
  Leasing = 'leasing',
  Marketplace = 'marketplace',
  Bankruptcy = 'bankruptcy',
  University = 'university',
  Bookmaker = 'bookmaker',
}

/**
 * Тип сортировки отзывов
 */
export enum SravniReviewsEnumsReviewOrder {
  ByDate = 'byDate',
  ByPopularity = 'byPopularity',
  HighRateFirst = 'highRateFirst',
  LowRateFirst = 'lowRateFirst',
  WithAnswers = 'withAnswers',
  WithRates = 'withRates',
  Checked = 'checked',
  Resolved = 'resolved',
  MostCommented = 'mostCommented',
  PartnersFirst = 'partnersFirst',
}

/**
 * Тип оценки для фильтрации отзывов
 */
export enum SravniReviewsEnumsReviewRate {
  Any = 'any',
  Five = 'five',
  Four = 'four',
  Three = 'three',
  Two = 'two',
  One = 'one',
  Good = 'good',
  Bad = 'bad',
}

/**
 * Статусы проверки оценки отзыва
 */
export enum SravniReviewsEnumsReviewRateStatus {
  Unknown = 'unknown',
  RateNotAvailable = 'rateNotAvailable',
  RateChecking = 'rateChecking',
  RateApproved = 'rateApproved',
  RateModified = 'rateModified',
  RateRejected = 'rateRejected',
}

/**
 * статус отзыва
 */
export enum SravniReviewsEnumsReviewStatus {
  Checking = 'checking',
  Checked = 'checked',
  PreModeration = 'preModeration',
}

export enum SravniReviewsEnumsUiComponentType {
  Widget = 'widget',
  Banner = 'banner',
  WhiteLabel = 'whiteLabel',
  Link = 'link',
  Api = 'api',
}

export enum SravniReviewsEnumsUiConfigurationItemType {
  Number = 'number',
  Text = 'text',
  Boolean = 'boolean',
  DateTime = 'dateTime',
  Color = 'color',
  Theme = 'theme',
  List = 'list',
  Container = 'container',
  ThemeContainer = 'themeContainer',
  JsonObject = 'jsonObject',
}

export enum SravniReviewsEnumsUserDataStatus {
  None = 'none',
  Requested = 'requested',
  Received = 'received',
  Approved = 'approved',
  Rejected = 'rejected',
}

export interface SravniReviewsFilterInfo {
  /** @format int32 */
  id?: number;
  name?: string | null;
  alias?: string | null;
}

/**
 * Метаинформация файла в рамках системы отзывов
 */
export interface SravniReviewsIAttachment {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /**
   * Дата загрузки
   * @format date-time
   */
  created?: string;

  /** Наименование файла */
  name?: string | null;

  /** Расширение файла */
  extension?: string | null;

  /** Ссылка на файл */
  url?: string | null;

  /** Путь к файлу */
  path?: string | null;
}

export interface SravniReviewsICompanyDailyReviewAggregatedRating {
  /**
   * Количество с ответами
   * @format int32
   */
  withAnswers?: number;

  /**
   * Количество без ответов
   * @format int32
   */
  withoutAnswers?: number;

  /**
   * Среднее время ответа
   * @format int64
   */
  responseTimeTicks?: number;

  /**
   * Количество с решениями
   * @format int32
   */
  resolved?: number;

  /**
   * Количество без решений
   * @format int32
   */
  unresolved?: number;

  /**
   * Среднее время на решние вопроса
   * @format int64
   */
  resolutionTimeTicks?: number;

  /**
   * Количество зачтенных отзывов
   * @format int32
   */
  approved?: number;

  /**
   * Количество заблокированных отзывов
   * @format int32
   */
  blocked?: number;

  /**
   * null - признак не указан, либо общий расчет рейтинга
   * true - рейтинг по отзывам с признаком юридическое лицо
   * false - рейтинг по отзывам с признаком физическое лицо
   */
  isLegal?: boolean | null;

  /** @format double */
  complexCalculatedRatingValue?: number;
  organizationId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;

  /** @format double */
  ratingValue?: number;

  /** @format double */
  totalValue?: number;

  /** @format int32 */
  reviewTag?: number;
  serviceCode?: string | null;

  /** @format int32 */
  participantsCount?: number;

  /**
   * Дата/Время создания
   * @format date-time
   */
  created?: string;
}

export interface SravniReviewsIntegrationIdentityReviewUserModel {
  /** @format int32 */
  userId?: number | null;
  authorEmail?: string | null;
  authorName?: string | null;
  authorLastName?: string | null;
  authorPhone?: string | null;
  companyId?: string | null;
  isBlocked?: boolean;
  abPlatform?: string | null;
  reputationIsDemo?: boolean;
}

export interface SravniReviewsLocationData {
  /** @format int32 */
  id?: number;
  alias?: string | null;
  name?: string | null;
  fullName?: string | null;
  route?: string | null;

  /** @format double */
  latitude?: number | null;

  /** @format double */
  longitude?: number | null;
  nameLocative?: string | null;
}

export interface SravniReviewsModelsChartsAreaSeriesData {
  dataLabel?: string | null;
  description?: string | null;
  drilldown?: string | null;
  id?: string | null;

  /** @format double */
  labelRank?: number | null;
  name?: string | null;
  selected?: boolean | null;

  /** @format double */
  x?: number | null;

  /** @format double */
  y?: number | null;
}

export interface SravniReviewsModelsChartsSeries {
  id?: string | null;
  name?: string | null;

  /** @format double */
  pointInterval?: number | null;

  /** @format double */
  pointStart?: number | null;
  stack?: string | null;
  type?: SravniReviewsModelsChartsTypeSeries;
  data?: SravniReviewsModelsChartsAreaSeriesData[] | null;
}

export enum SravniReviewsModelsChartsTypeSeries {
  Null = 'null',
  Line = 'line',
  Spline = 'spline',
  Column = 'column',
  Area = 'area',
  Areaspline = 'areaspline',
  Pie = 'pie',
  Arearange = 'arearange',
  Areasplinerange = 'areasplinerange',
  Boxplot = 'boxplot',
  Bubble = 'bubble',
  Columnrange = 'columnrange',
  Errorbar = 'errorbar',
  Funnel = 'funnel',
  Gauge = 'gauge',
  Scatter = 'scatter',
  Waterfall = 'waterfall',
  Bar = 'bar',
  Heatmap = 'heatmap',
  Pyramid = 'pyramid',
  Polygon = 'polygon',
  Treemap = 'treemap',
  Solidgauge = 'solidgauge',
  Bellcurve = 'bellcurve',
  Bullet = 'bullet',
  Histogram = 'histogram',
  Pareto = 'pareto',
  Sankey = 'sankey',
  Scatter3D = 'scatter3d',
  Streamgraph = 'streamgraph',
  Sunburst = 'sunburst',
  Tilemap = 'tilemap',
  Variablepie = 'variablepie',
  Variwide = 'variwide',
  Vector = 'vector',
  Windbarb = 'windbarb',
  Wordcloud = 'wordcloud',
  Xrange = 'xrange',
}

export interface SravniReviewsModelsExternalApiExternalApiCommentModel {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  created?: string;

  /** @format int32 */
  authorId?: number | null;
  authorName?: string | null;
  isCompanyResponse?: boolean;

  /** @format int32 */
  reviewId?: number;
  text?: string | null;
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
}

export interface SravniReviewsModelsExternalApiExternalApiReviewModel {
  /** @format date-time */
  date?: string | null;

  /** @format int32 */
  rate?: number | null;

  /** статус отзыва */
  status?: SravniReviewsEnumsReviewStatus;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;

  /** @format int32 */
  authorId?: number | null;
  authorName?: string | null;
  hasCompanyResponse?: boolean;

  /** @format date-time */
  problemSolutionDate?: string | null;
  problemSolved?: boolean;
  specificProductName?: string | null;

  /** @format int32 */
  id?: number;
  title?: string | null;
  text?: string | null;
  isLegal?: boolean | null;
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
  location?: SravniReviewsLocationData;
  serviceTag?: SravniReviewsModelsServiceTagModel;
}

export interface SravniReviewsModelsExternalApiExternalApiReviewSortedByEventModel {
  eventType?: SravniReviewsEnumsExternalApiActivityEventType;

  /** @format date-time */
  lastModifiedDate?: string;

  /** @format date-time */
  date?: string | null;

  /** @format int32 */
  rate?: number | null;

  /** статус отзыва */
  status?: SravniReviewsEnumsReviewStatus;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;

  /** @format int32 */
  authorId?: number | null;
  authorName?: string | null;
  hasCompanyResponse?: boolean;

  /** @format date-time */
  problemSolutionDate?: string | null;
  problemSolved?: boolean;
  specificProductName?: string | null;

  /** @format int32 */
  id?: number;
  title?: string | null;
  text?: string | null;
  isLegal?: boolean | null;
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
  location?: SravniReviewsLocationData;
  serviceTag?: SravniReviewsModelsServiceTagModel;
}

export interface SravniReviewsModelsExternalApiExternalApiReviewWithUserDataModel {
  authorPhone?: string | null;

  /** @format date-time */
  date?: string | null;

  /** @format int32 */
  rate?: number | null;

  /** статус отзыва */
  status?: SravniReviewsEnumsReviewStatus;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;

  /** @format int32 */
  authorId?: number | null;
  authorName?: string | null;
  hasCompanyResponse?: boolean;

  /** @format date-time */
  problemSolutionDate?: string | null;
  problemSolved?: boolean;
  specificProductName?: string | null;

  /** @format int32 */
  id?: number;
  title?: string | null;
  text?: string | null;
  isLegal?: boolean | null;
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
  location?: SravniReviewsLocationData;
  serviceTag?: SravniReviewsModelsServiceTagModel;
}

export interface SravniReviewsModelsExternalApiExternalApiReviewWithUserDataSortedByEventModel {
  authorPhone?: string | null;
  eventType?: SravniReviewsEnumsExternalApiActivityEventType;

  /** @format date-time */
  lastModifiedDate?: string;

  /** @format date-time */
  date?: string | null;

  /** @format int32 */
  rate?: number | null;

  /** статус отзыва */
  status?: SravniReviewsEnumsReviewStatus;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;

  /** @format int32 */
  authorId?: number | null;
  authorName?: string | null;
  hasCompanyResponse?: boolean;

  /** @format date-time */
  problemSolutionDate?: string | null;
  problemSolved?: boolean;
  specificProductName?: string | null;

  /** @format int32 */
  id?: number;
  title?: string | null;
  text?: string | null;
  isLegal?: boolean | null;
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
  location?: SravniReviewsLocationData;
  serviceTag?: SravniReviewsModelsServiceTagModel;
}

export interface SravniReviewsModelsRatingAggregatedRatingModel {
  /** @format date-time */
  created?: string;
  organizationId?: string | null;
  organizationName?: string | null;
  organizationAlias?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;

  /** @format double */
  totalValue?: number;
  reviewTag?: string | null;

  /** @format int32 */
  participantsCount?: number;

  /** @format double */
  ratingValue?: number;

  /** @format date-time */
  updated?: string | null;

  /** @format int32 */
  id?: number;
}

export interface SravniReviewsModelsRatingAggregatedRatingStatsModel {
  /** @format date-time */
  created?: string;

  /** @format int32 */
  participantsCount?: number;

  /** @format double */
  ratingValue?: number;
  tag?: string | null;
}

export interface SravniReviewsModelsRatingCompanyDailyReviewAggregatedRatingModel {
  /** @format int32 */
  withAnswers?: number;

  /** @format int32 */
  withoutAnswers?: number;

  /** @format int64 */
  responseTimeTicks?: number;

  /** @format int32 */
  resolved?: number;

  /** @format int32 */
  unresolved?: number;

  /** @format int64 */
  resolutionTimeTicks?: number;

  /** @format int32 */
  approved?: number;

  /** @format int32 */
  blocked?: number;

  /** @format double */
  sumRating?: number;

  /** @format double */
  sumRatingCoefficient?: number;

  /** @format double */
  individualRating?: number;

  /** @format double */
  individualRatingImportance?: number;
  locationInfo?: SravniReviewsLocationData;
  filterInfo?: SravniReviewsFilterInfo;

  /** @format int32 */
  position?: number;

  /** @format int32 */
  totalPositions?: number;
  isLegal?: boolean | null;

  /** @format double */
  complexCalculatedRatingValue?: number;

  /** @format date-time */
  created?: string;
  organizationId?: string | null;
  organizationName?: string | null;
  organizationAlias?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;

  /** @format double */
  totalValue?: number;
  reviewTag?: string | null;

  /** @format int32 */
  participantsCount?: number;

  /** @format double */
  ratingValue?: number;

  /** @format date-time */
  updated?: string | null;

  /** @format int32 */
  id?: number;
}

export interface SravniReviewsModelsReputationReputationCompanyResponseStatsByRatingModel {
  /** @format int32 */
  ratingValue?: number;

  /** @format int32 */
  reviewsCount?: number;

  /** @format int32 */
  answersCount?: number;

  /** @format double */
  partByPercent?: number;
  avgResponseTime?: SravniReviewsModelsReputationTime;
}

export interface SravniReviewsModelsReputationReputationCompanyResponseStatsByTagModel {
  /** @format int32 */
  productTag?: number;
  statsByRating?: SravniReviewsModelsReputationReputationCompanyResponseStatsByRatingModel[] | null;

  /** @format int32 */
  reviewsCount?: number;

  /** @format int32 */
  answersCount?: number;

  /** @format double */
  partByPercent?: number;
  avgResponseTime?: SravniReviewsModelsReputationTime;
}

export interface SravniReviewsModelsReputationReputationCompanyResponseStatsModel {
  statsByRating?: SravniReviewsModelsReputationReputationCompanyResponseStatsByRatingModel[] | null;
  statsByProducts?: SravniReviewsModelsReputationReputationCompanyResponseStatsByTagModel[] | null;

  /** @format int32 */
  reviewsCount?: number;

  /** @format int32 */
  answersCount?: number;

  /** @format double */
  partByPercent?: number;
  avgResponseTime?: SravniReviewsModelsReputationTime;
}

export interface SravniReviewsModelsReputationReputationCsvModel {
  /** @format byte */
  fileName?: string | null;

  /** @format byte */
  content?: string | null;
}

export interface SravniReviewsModelsReputationReputationDetailByRating {
  /** @format int32 */
  ratingValue?: number;

  /** @format int32 */
  approvedCount?: number;
}

export interface SravniReviewsModelsReputationReputationDetailedStatsModel {
  /** @format date-time */
  from?: string;

  /** @format date-time */
  to?: string;

  /** @format int32 */
  reviewsCount?: number;

  /** @format int32 */
  approvedCount?: number;

  /** @format int32 */
  rejectedCount?: number;

  /** @format double */
  avgRatingValue?: number;

  /** @format int32 */
  answersCount?: number;

  /** @format int32 */
  resolvedCount?: number;
  avgResponseTime?: SravniReviewsModelsReputationTime;
  avgResolvedTime?: SravniReviewsModelsReputationTime;

  /** @format int32 */
  positiveVotesCount?: number;

  /** @format int32 */
  negativeVotesCount?: number;
  ratingStats?: SravniReviewsModelsReputationReputationDetailByRating[] | null;
}

export interface SravniReviewsModelsReputationReputationLocationStats {
  /** @format int32 */
  id?: number;
  name?: string | null;
  nameLocative?: string | null;

  /** @format double */
  avgRatingValue?: number;

  /** @format int32 */
  approvedReviewsCount?: number;

  /** @format double */
  latitude?: number | null;

  /** @format double */
  longitude?: number | null;
}

export interface SravniReviewsModelsReputationReputationPerformanceOverviewModel {
  statsByRating?: SravniReviewsModelsReputationReputationPerformanceOverviewPartModel[] | null;

  /** @format double */
  increasePercent?: number;

  /** @format int32 */
  approvedCount?: number;
}

export interface SravniReviewsModelsReputationReputationPerformanceOverviewPartModel {
  /** @format int32 */
  ratingValue?: number;

  /** @format double */
  partPercent?: number;

  /** @format int32 */
  approvedCount?: number;
}

export interface SravniReviewsModelsReputationReputationPositionByDayModel {
  /** @format date-time */
  date?: string;

  /** @format int32 */
  postision?: number;

  /** @format int32 */
  total?: number;
}

export interface SravniReviewsModelsReputationReputationPositionModel {
  /** @format int32 */
  position?: number;

  /** @format int32 */
  total?: number;

  /** @format double */
  bayesRating?: number;
  ratingTrendLine?: SravniReviewsModelsReputationReputationPositionByDayModel[] | null;
}

export interface SravniReviewsModelsReputationReputationRatingByLastMonth {
  fullPeriod?: boolean;

  /** @format double */
  ratingValue?: number;

  /** @format int32 */
  approvedCount?: number;

  /** @format int32 */
  checkedCount?: number;

  /** @format int32 */
  participantsCount?: number;

  /** @format int32 */
  problemSolvedCount?: number;
}

export interface SravniReviewsModelsReputationReputationRatingCountedStats {
  /** @format int32 */
  ratingValue?: number;

  /** @format int32 */
  reviewsCount?: number;

  /** @format int32 */
  approvedCount?: number;

  /** @format int32 */
  rejectedCount?: number;
}

export interface SravniReviewsModelsReputationReputationRatingPeriodStats {
  /** @format date-time */
  from?: string;

  /** @format date-time */
  to?: string;

  /** @format int32 */
  totalApprovedCount?: number;

  /** @format int32 */
  reviewsCount?: number;

  /** @format int32 */
  onModerationReviewsCount?: number;
  ratingCountedStats?: SravniReviewsModelsReputationReputationRatingCountedStats[] | null;
}

export interface SravniReviewsModelsReputationReputationResponse {
  organizationId?: string | null;
  ratingStats?: SravniReviewsModelsReputationReviewsRatingModel[] | null;
}

export interface SravniReviewsModelsReputationReputationStatsModel {
  organizationId?: string | null;
  productTag?: string | null;
  groupedType?: SravniReviewsEnumsReputationGroupingType;

  /** @format double */
  avgRatingValue?: number;

  /** @format int32 */
  approvedReviewsCount?: number;

  /** @format int32 */
  reviewsCount?: number;
  statsByLocations?: SravniReviewsModelsReputationReputationLocationStats[] | null;
  statByPeriods?: SravniReviewsModelsReputationReputationRatingPeriodStats[] | null;
}

export interface SravniReviewsModelsReputationReviewsRatingModel {
  productTag?: string | null;

  /** @format int32 */
  approvedCount?: number;

  /** @format double */
  ratingValue?: number;
}

export interface SravniReviewsModelsReputationTime {
  /** @format int32 */
  days?: number;

  /** @format int32 */
  hours?: number;

  /** @format int32 */
  minutes?: number;

  /** @format int32 */
  seconds?: number;

  /** @format int32 */
  milliseconds?: number;
}

export interface SravniReviewsModelsReviewBackofficeReviewCommentListItemModel {
  ip?: string | null;
  fingerPrint?: string | null;
  authorEmail?: string | null;
  authorPhone?: string | null;
  authorPhoneFormatted?: string | null;
  isBlocked?: boolean;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  reviewObjectType?: SravniReviewsEnumsReviewObjectType;

  /** @format int32 */
  reviewTag?: number;
  reviewObjectId?: string | null;

  /** @format int32 */
  rootId?: number;
  rootTitle?: string | null;

  /** статус отзыва */
  reviewStatus?: SravniReviewsEnumsReviewStatus;
  reviewStatusName?: string | null;
  lastModificationTypeName?: string | null;
  lastModifiedBy?: string | null;

  /** @format date-time */
  lastModificationDate?: string | null;

  /** @format int32 */
  userId?: number;
  authorName?: string | null;
  authorLastName?: string | null;
  authorRole?: string | null;
  authorRoleDescription?: string | null;

  /** @format date-time */
  date?: string;

  /** @format int32 */
  commentsCount?: number;
  canDelete?: boolean;
  canEdit?: boolean;
  canEditIsMain?: boolean;
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;
  isAuthorDeleted?: boolean;

  /** @format date-time */
  createdToMoscow?: string;

  /** @format int32 */
  id?: number;

  /** @format int32 */
  parentId?: number | null;

  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId: number;
  text: string;
  isMain?: boolean;
}

export interface SravniReviewsModelsReviewBackofficeReviewListItemModel {
  authorPhone?: string | null;
  authorPhoneFormatted?: string | null;
  messageForCompany?: string | null;
  reviewUserData?: SravniReviewsModelsReviewReviewUserDataModel;
  authorEmail?: string | null;
  utm?: SravniReviewsUtm;
  attachment?: string | null;

  /** @format int32 */
  rootId?: number | null;
  rootTitle?: string | null;
  ip?: string | null;

  /** статус отзыва */
  reviewStatus?: SravniReviewsEnumsReviewStatus;
  followUp?: boolean;
  moderatorEmail?: string | null;
  lastModificationTypeName?: string | null;
  lastModifiedBy?: string | null;

  /** @format date-time */
  lastModificationDate?: string | null;
  fingerPrint?: string | null;
  checked?: boolean;
  hasCompanyRepresentative?: boolean;
  deleted?: boolean;
  isBlocked?: boolean;

  /** @format date-time */
  followUpDate?: string | null;

  /** @format int32 */
  followUpDaysCount?: number;
  reviewNote?: SravniReviewsModelsReviewReviewNoteModel;

  /** @format int32 */
  commentsCount?: number;
  hasCompanyResponse?: boolean;
  authorName?: string | null;
  authorLastName?: string | null;
  authorRole?: string | null;
  authorRoleDescription?: string | null;
  isAuthorDeleted?: boolean;

  /** @format int32 */
  rating?: number | null;

  /** Статусы проверки оценки отзыва */
  ratingStatus?: SravniReviewsEnumsReviewRateStatus;
  problemSolved?: boolean;
  userDataStatus?: SravniReviewsEnumsUserDataStatus;

  /** @format date-time */
  problemSolutionDate?: string | null;
  attachments?: string[] | null;
  canEditReview?: boolean;
  canDelete?: boolean;
  canResolve?: boolean;
  canEditReviewHiddenFields?: boolean;
  isExternal?: boolean;
  externalId?: string | null;
  externalSource?: string | null;
  externalUrl?: string | null;
  votes?: SravniReviewsModelsReviewVoteSummaryReadModel;
  vote?: boolean | null;
  isRecommendedByUser?: boolean | null;
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;
  positiveTags?: SravniReviewsTagModel[] | null;
  negativeTags?: SravniReviewsTagModel[] | null;
  requireUserData?: boolean;

  /** @format date-time */
  createdToMoscow?: string;
  locationData?: SravniReviewsLocationData;

  /** @format int32 */
  userId?: number | null;

  /** @format int32 */
  id?: number;

  /** @format date-time */
  date?: string;

  /** @format int32 */
  locationId: number;
  title: string;
  text: string;
  reviewObjectId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  reviewObjectType?: SravniReviewsEnumsReviewObjectType;
  reviewTag?: string | null;
  additionalJsonData?: string | null;
  additionalInfoUiConfiguration?: string | null;

  /** @format int32 */
  schemeTemplateId?: number;
  isLegal?: boolean | null;
  isClient?: boolean | null;

  /** @format int32 */
  ratingBase?: number | null;
  specificProductId?: string | null;
  specificProductName?: string | null;
}

export interface SravniReviewsModelsReviewBackofficeReviewsReportItemModel {
  link?: string | null;

  /** @format date-time */
  date?: string;
  location?: string | null;
  organizationName?: string | null;
  reviewTag?: string | null;
  status?: string | null;

  /** @format int32 */
  rating?: number;
  ratingStatus?: string | null;
  hasCompanyResponse?: string | null;
  answeredBy?: string | null;
  authorPhone?: string | null;
  ip?: string | null;
  fingerPrint?: string | null;
  userNameForAppeal?: string | null;
  userPhoneForAppeal?: string | null;

  /** @format date-time */
  userBirthDateForAppeal?: string | null;
  messageForCompany?: string | null;
  text?: string | null;
  isLegal?: string | null;
  note?: string | null;
  utmSource?: string | null;
  utmCampaign?: string | null;
  utmMedium?: string | null;
}

export interface SravniReviewsModelsReviewCommentCheckModel {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  commentId?: number;
  checked?: boolean;
}

export interface SravniReviewsModelsReviewExcelImportModel {
  /** @format byte */
  file: string;
  reviewTag: string;
  organizationType: SravniReviewsEnumsOrganizationType;

  /** Статусы проверки оценки отзыва */
  reviewRateStatus?: SravniReviewsEnumsReviewRateStatus;
  requireModeration?: boolean;
  setAllAsChecked?: boolean;
}

export interface SravniReviewsModelsReviewProductTagsCountModel {
  serviceTagCode?: string | null;
  serviceTagName?: string | null;
  serviceTagAlias?: string | null;
  positiveTags?: SravniReviewsModelsReviewTagsCountModel[] | null;
  negativeTags?: SravniReviewsModelsReviewTagsCountModel[] | null;
}

export interface SravniReviewsModelsReviewRatingApprovalModel {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId?: number;
  approved?: boolean | null;

  /** @format int32 */
  rating?: number;
}

export interface SravniReviewsModelsReviewRawReviewCountModel {
  organizationName?: string | null;

  /** @format int32 */
  checkingReviewCount?: number;

  /** @format int32 */
  notConfirmedReviewCount?: number;

  /** @format date-time */
  firstRawReviewCreatedDate?: string;
}

export interface SravniReviewsModelsReviewResolveReviewModel {
  /** @format int32 */
  id?: number;
  problemSolved?: boolean | null;
}

export interface SravniReviewsModelsReviewReviewActivityEventModel {
  /** @format date-time */
  created?: string;

  /** @format int32 */
  id?: number;
  activityEventType?: SravniReviewsEnumsActivityEventType;

  /** @format int32 */
  entityId?: number | null;

  /** @format int32 */
  reviewId?: number;
  userRole?: string | null;
  userContact?: string | null;

  /** @format int32 */
  userId?: number;
  abPlatform?: string | null;
  reviewUrl?: string | null;
  entityUrl?: string | null;
  organizationName?: string | null;
  oldValues?: SravniReviewsNameValueModel[] | null;
  newValues?: SravniReviewsNameValueModel[] | null;
}

export interface SravniReviewsModelsReviewReviewAdditionalInfoSchemeReadModel {
  organizationId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;
  serviceTag?: string | null;
  uiConfiguration?: string | null;

  /** @format int32 */
  id?: number;
  deleted?: boolean;

  /** @format date-time */
  deleteDate?: string | null;
  isPublic?: boolean;
}

export interface SravniReviewsModelsReviewReviewAdditionalInfoSchemeUpdateModel {
  organizationId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;
  productTag?: string | null;
  configuration?: string | null;
}

export interface SravniReviewsModelsReviewReviewCheckModel {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId?: number;
  checked?: boolean;
}

export interface SravniReviewsModelsReviewReviewCommentReadModel {
  /** @format int32 */
  userId?: number;
  authorName?: string | null;
  authorLastName?: string | null;
  authorRole?: string | null;
  authorRoleDescription?: string | null;

  /** @format date-time */
  date?: string;

  /** @format int32 */
  commentsCount?: number;
  canDelete?: boolean;
  canEdit?: boolean;
  canEditIsMain?: boolean;
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;
  isAuthorDeleted?: boolean;

  /** @format date-time */
  createdToMoscow?: string;

  /** @format int32 */
  id?: number;

  /** @format int32 */
  parentId?: number | null;

  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId: number;
  text: string;
  isMain?: boolean;
}

export interface SravniReviewsModelsReviewReviewCommentUpdateModel {
  utm?: SravniReviewsUtm;
  fingerPrint: string;
  ip: string;

  /** @format int32 */
  authorLocationId?: number;
  authorFirstName?: string | null;
  authorLastName?: string | null;

  /** @format int32 */
  id?: number;

  /** @format int32 */
  parentId?: number | null;

  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId: number;
  text: string;
  isMain?: boolean;
}

export interface SravniReviewsModelsReviewReviewListItemModel {
  /** @format int32 */
  commentsCount?: number;
  hasCompanyResponse?: boolean;
  authorName?: string | null;
  authorLastName?: string | null;
  authorRole?: string | null;
  authorRoleDescription?: string | null;
  isAuthorDeleted?: boolean;

  /** @format int32 */
  rating?: number | null;

  /** Статусы проверки оценки отзыва */
  ratingStatus?: SravniReviewsEnumsReviewRateStatus;
  problemSolved?: boolean;
  userDataStatus?: SravniReviewsEnumsUserDataStatus;

  /** @format date-time */
  problemSolutionDate?: string | null;
  attachment?: string | null;
  attachments?: string[] | null;
  canEditReview?: boolean;
  canDelete?: boolean;
  canResolve?: boolean;
  canEditReviewHiddenFields?: boolean;
  isExternal?: boolean;
  externalId?: string | null;
  externalSource?: string | null;
  externalUrl?: string | null;
  isBlocked?: boolean;
  votes?: SravniReviewsModelsReviewVoteSummaryReadModel;
  vote?: boolean | null;
  isRecommendedByUser?: boolean | null;
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;
  positiveTags?: SravniReviewsTagModel[] | null;
  negativeTags?: SravniReviewsTagModel[] | null;
  requireUserData?: boolean;

  /** @format date-time */
  createdToMoscow?: string;
  locationData?: SravniReviewsLocationData;
  deleted?: boolean;

  /** @format int32 */
  userId?: number | null;

  /** @format int32 */
  id?: number;

  /** @format date-time */
  date?: string;

  /** @format int32 */
  locationId: number;
  title: string;
  text: string;
  reviewObjectId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  reviewObjectType?: SravniReviewsEnumsReviewObjectType;
  reviewTag?: string | null;
  additionalJsonData?: string | null;
  additionalInfoUiConfiguration?: string | null;

  /** @format int32 */
  schemeTemplateId?: number;
  isLegal?: boolean | null;
  isClient?: boolean | null;

  /** @format int32 */
  ratingBase?: number | null;
  specificProductId?: string | null;
  specificProductName?: string | null;
}

export interface SravniReviewsModelsReviewReviewNoteModel {
  /** @format int32 */
  reviewId?: number;
  text?: string | null;
}

export interface SravniReviewsModelsReviewReviewReadModel {
  authorName?: string | null;
  authorLastName?: string | null;
  authorRole?: string | null;
  authorRoleDescription?: string | null;
  isAuthorDeleted?: boolean;

  /** @format int32 */
  rating?: number | null;

  /** Статусы проверки оценки отзыва */
  ratingStatus?: SravniReviewsEnumsReviewRateStatus;
  problemSolved?: boolean;
  userDataStatus?: SravniReviewsEnumsUserDataStatus;

  /** @format date-time */
  problemSolutionDate?: string | null;
  attachment?: string | null;
  attachments?: string[] | null;
  canEditReview?: boolean;
  canDelete?: boolean;
  canResolve?: boolean;
  canEditReviewHiddenFields?: boolean;
  isExternal?: boolean;
  externalId?: string | null;
  externalSource?: string | null;
  externalUrl?: string | null;
  isBlocked?: boolean;
  votes?: SravniReviewsModelsReviewVoteSummaryReadModel;
  vote?: boolean | null;
  isRecommendedByUser?: boolean | null;
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;
  positiveTags?: SravniReviewsTagModel[] | null;
  negativeTags?: SravniReviewsTagModel[] | null;

  /** @format int32 */
  commentsCount?: number;
  requireUserData?: boolean;

  /** @format date-time */
  createdToMoscow?: string;
  locationData?: SravniReviewsLocationData;
  deleted?: boolean;

  /** @format int32 */
  userId?: number | null;

  /** @format int32 */
  id?: number;

  /** @format date-time */
  date?: string;

  /** @format int32 */
  locationId: number;
  title: string;
  text: string;
  reviewObjectId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  reviewObjectType?: SravniReviewsEnumsReviewObjectType;
  reviewTag?: string | null;
  additionalJsonData?: string | null;
  additionalInfoUiConfiguration?: string | null;

  /** @format int32 */
  schemeTemplateId?: number;
  isLegal?: boolean | null;
  isClient?: boolean | null;

  /** @format int32 */
  ratingBase?: number | null;
  specificProductId?: string | null;
  specificProductName?: string | null;
}

export interface SravniReviewsModelsReviewReviewTagsCountModel {
  organizationId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;

  /** @format date-time */
  from?: string;

  /** @format date-time */
  to?: string;
  productTags?: SravniReviewsModelsReviewProductTagsCountModel[] | null;
}

export interface SravniReviewsModelsReviewReviewUpdateModel {
  /** @format int32 */
  externalId?: number | null;
  externalSource?: string | null;
  messageForCompany?: string | null;
  reviewUserData?: SravniReviewsModelsReviewReviewUserDataModel;
  utm?: SravniReviewsUtm;
  fingerPrint: string;
  ip: string;

  /** @format uuid */
  attachment?: string;
  attachments?: string[] | null;
  isRecommendedByUser?: boolean | null;
  positiveTags?: number[] | null;
  negativeTags?: number[] | null;

  /** @format int32 */
  userId?: number | null;

  /** @format int32 */
  id?: number;

  /** @format date-time */
  date?: string;

  /** @format int32 */
  locationId: number;
  title: string;
  text: string;
  reviewObjectId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  reviewObjectType?: SravniReviewsEnumsReviewObjectType;
  reviewTag?: string | null;
  additionalJsonData?: string | null;
  additionalInfoUiConfiguration?: string | null;

  /** @format int32 */
  schemeTemplateId?: number;
  isLegal?: boolean | null;
  isClient?: boolean | null;

  /** @format int32 */
  rating?: number | null;

  /** @format int32 */
  ratingBase?: number | null;
  specificProductId?: string | null;
  specificProductName?: string | null;
}

export interface SravniReviewsModelsReviewReviewUpdateValidatableModel {
  /** @format int32 */
  externalId?: number | null;
  externalSource?: string | null;
  messageForCompany?: string | null;
  reviewUserData?: SravniReviewsModelsReviewReviewUserDataModel;
  utm?: SravniReviewsUtm;
  fingerPrint: string;
  ip: string;

  /** @format uuid */
  attachment?: string;
  attachments?: string[] | null;
  isRecommendedByUser?: boolean | null;
  positiveTags?: number[] | null;
  negativeTags?: number[] | null;

  /** @format int32 */
  userId?: number | null;

  /** @format int32 */
  id?: number;

  /** @format date-time */
  date?: string;

  /** @format int32 */
  locationId: number;
  title: string;
  text: string;
  reviewObjectId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  reviewObjectType?: SravniReviewsEnumsReviewObjectType;
  reviewTag?: string | null;
  additionalJsonData?: string | null;
  additionalInfoUiConfiguration?: string | null;

  /** @format int32 */
  schemeTemplateId?: number;
  isLegal?: boolean | null;
  isClient?: boolean | null;

  /** @format int32 */
  rating?: number | null;

  /** @format int32 */
  ratingBase?: number | null;
  specificProductId?: string | null;
  specificProductName?: string | null;
}

export interface SravniReviewsModelsReviewReviewUserDataModel {
  additionalInfo?: string | null;

  /** @format date-time */
  userBirthDateForAppeal?: string | null;
  userNameForAppeal?: string | null;
  userPhoneForAppeal?: string | null;
  isApproved?: boolean | null;

  /** @format date-time */
  registrationDate?: string | null;

  /** @format int32 */
  questionsCount?: number | null;

  /** @format int32 */
  reviewsCount?: number | null;
  isEmpty?: boolean;
}

export interface SravniReviewsModelsReviewReviewsCountByOrganizationModel {
  organizationId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;

  /** @format int32 */
  reviewsCount?: number;
}

export interface SravniReviewsModelsReviewReviewsCountModel {
  /** @format int32 */
  id?: number;
  organizationId?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;
  serviceTag?: string | null;

  /** @format int32 */
  ratingValue?: number | null;

  /** @format int32 */
  locationId?: number | null;

  /** @format int32 */
  reviewCount?: number;
}

export interface SravniReviewsModelsReviewReviewsCountReadModel {
  groupedByServices?: SravniReviewsModelsReviewReviewsCountModel[] | null;
  groupedByRatingValue?: SravniReviewsModelsReviewReviewsCountModel[] | null;
}

export interface SravniReviewsModelsReviewTagsCountModel {
  name?: string | null;
  description?: string | null;
  title?: string | null;

  /** @format int32 */
  count?: number;
}

export interface SravniReviewsModelsReviewUpdateReviewNoteModel {
  text?: string | null;
}

export interface SravniReviewsModelsReviewUserContentReadModel {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  date?: string;
  contentType?: string | null;
  text?: string | null;
  title?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  subjectType?: SravniReviewsEnumsReviewObjectType;
  subjectId?: string | null;
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;
  icon?: string | null;
  organizationAlias?: string | null;

  /** @format int32 */
  reviewId?: number;
}

export interface SravniReviewsModelsReviewVoteSummaryReadModel {
  /** @format int32 */
  positive?: number;

  /** @format int32 */
  negative?: number;
}

export interface SravniReviewsModelsReviewVoteUpdateModel {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId: number;
  positive?: boolean;
  fingerPrint: string;
}

export interface SravniReviewsModelsSeoSeoOrganizationReviewsModel {
  alias?: string | null;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;

  /** @format int32 */
  reviewId?: number;
}

export interface SravniReviewsModelsSeoSeoReviewsModel {
  items?:
    | SystemCollectionsGenericKeyValuePair2SystemStringSystemPrivateCoreLibVersion6000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemCollectionsGenericList1SystemInt32SystemPrivateCoreLibVersion6000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion6000CultureNeutralPublicKeyToken7Cec85D7Bea7798E[]
    | null;
}

export interface SravniReviewsModelsSeoSeoSummaryModel {
  /** @format int32 */
  reviewsCount?: number;

  /** @format int32 */
  negativesCount?: number;

  /** @format int32 */
  positivesCount?: number;

  /** @format int32 */
  answersCount?: number;

  /** @format int32 */
  solutionsCount?: number;
}

export interface SravniReviewsModelsServiceTagModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  alias?: string | null;
  code?: string | null;
}

export interface SravniReviewsModelsUiUiComponentModel {
  head?: string | null;
  body?: string | null;
  externalId?: string | null;
  configuration?: SravniReviewsUiComponentConfigurationItem[] | null;
  type?: SravniReviewsEnumsUiComponentType;

  /** @format int32 */
  id?: number;
  name?: string | null;
  description?: string | null;
  deleted?: boolean;
}

export interface SravniReviewsModelsUsersModeratorInfoModel {
  /** @format int32 */
  id?: number;
  email?: string | null;
}

export interface SravniReviewsModelsUsersOrganizationUserModel {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  id: number;
  organizationId: string;
  receiveNotifications?: boolean;
  responsible?: boolean;
  deleted?: boolean;

  /** @format date-time */
  deleteDate?: string | null;

  /** @format date-time */
  lastReplyDate?: string | null;
  reputationIsDemo?: boolean;
  firstName?: string | null;
  lastName?: string | null;
}

export interface SravniReviewsModelsUsersResponsibleOrganizationUserModel {
  /** @format int32 */
  id?: number;
  organizationId?: string | null;
  pseudonym?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface SravniReviewsModelsUsersUserBlockModel {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  created?: string;

  /** @format int32 */
  userId?: number;
  userEmail?: string | null;
  userPhone?: string | null;
  userName?: string | null;
  userLastName?: string | null;

  /** @format int32 */
  blockedBy?: number;
  blockedByContact?: string | null;
  comment: string;

  /** @format int32 */
  deletedBy?: number;
  deletedByContact?: string | null;
  deleted?: boolean;

  /** @format date-time */
  deleteDate?: string | null;
}

export interface SravniReviewsModelsViewsReviewViewsCountModel {
  /** @format int32 */
  reviewId?: number;

  /** @format int32 */
  views?: number;
}

export interface SravniReviewsModeratorToOrganizationsModel {
  /** @format int32 */
  id?: number;
  userEmail?: string | null;
  organizationsIds?: string[] | null;
}

export interface SravniReviewsNameValueModel {
  name?: string | null;
  value?: any;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsExternalApiExternalApiReviewModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsExternalApiExternalApiReviewModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsExternalApiExternalApiReviewSortedByEventModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsExternalApiExternalApiReviewSortedByEventModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsExternalApiExternalApiReviewWithUserDataModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsExternalApiExternalApiReviewWithUserDataModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsExternalApiExternalApiReviewWithUserDataSortedByEventModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsExternalApiExternalApiReviewWithUserDataSortedByEventModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsRatingCompanyDailyReviewAggregatedRatingModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsRatingCompanyDailyReviewAggregatedRatingModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReputationReputationDetailedStatsModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReputationReputationDetailedStatsModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewBackofficeReviewCommentListItemModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewBackofficeReviewCommentListItemModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewBackofficeReviewListItemModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewBackofficeReviewListItemModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewReviewAdditionalInfoSchemeReadModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewReviewAdditionalInfoSchemeReadModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewReviewCommentReadModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewReviewCommentReadModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewReviewListItemModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewReviewListItemModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsUiUiComponentModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsUiUiComponentModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsUsersOrganizationUserModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsUsersOrganizationUserModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsUsersUserBlockModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsUsersUserBlockModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsTagModelSravniReviewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsTagModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

export interface SravniReviewsReviewTagModel {
  /** @format int32 */
  reviewId?: number;

  /** @format int32 */
  tagId?: number;
}

export interface SravniReviewsServiceV2ModelsFilterItem {
  key?: any;

  /** Значение name */
  name?: string | null;

  /** Значение alias */
  alias?: string | null;
}

export interface SravniReviewsServiceModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  code?: string | null;
  alias?: string | null;
  includeInRating?: boolean;
  deleted?: boolean;

  /** @format date-time */
  deleteDate?: string | null;
}

export interface SravniReviewsTagModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  alias?: string | null;
  isPositive?: boolean;
  description?: string | null;
  title?: string | null;
  deleted?: boolean;
  productTags?: string[] | null;
  services?: SravniReviewsServiceModel[] | null;
}

export interface SravniReviewsTagServiceModel {
  /** @format int32 */
  productTagId?: number;

  /** @format int32 */
  tagId?: number;
}

export interface SravniReviewsUiComponentConfigurationItem {
  /** @format uuid */
  clientId?: string;
  image?: string | null;
  color?: string | null;
  allowSearch?: boolean;
  premiumOnly?: boolean;

  /** @format int32 */
  minimumInputLength?: number;
  dataSource?: SravniReviewsDdlItem[] | null;
  dataSourceUrl?: string | null;
  searchDisplayMember?: string | null;
  searchDisplayValue?: string | null;
  multiValue?: boolean;
  selectedValues?: any[] | null;
  customStyle?: string | null;
  children?: SravniReviewsUiComponentConfigurationItem[] | null;
  value?: string | null;
  name?: string | null;
  caption?: string | null;
  itemType?: SravniReviewsEnumsUiConfigurationItemType;
}

export interface SravniReviewsUpdateReviewTagModel {
  /** @format int32 */
  reviewId?: number;
  tagIds?: number[] | null;
}

export interface SravniReviewsUtm {
  utmSource?: string | null;
  utmCampaign?: string | null;
  utmMedium?: string | null;
}

export interface SystemCollectionsGenericKeyValuePair2SystemStringSystemPrivateCoreLibVersion6000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemCollectionsGenericList1SystemInt32SystemPrivateCoreLibVersion6000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion6000CultureNeutralPublicKeyToken7Cec85D7Bea7798E {
  key?: string | null;
  value?: number[] | null;
}

export interface AttachmentUploadCreatePayload {
  ContentType?: string;
  ContentDisposition?: string;
  Headers?: Record<string, string[]>;

  /** @format int64 */
  Length?: number;
  Name?: string;
  FileName?: string;
}

export interface CommentsListParams {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  ReviewId: number;

  /** @format int32 */
  ParentId?: number;
  IncludeDeleted?: boolean;
  OnlyCompanyResponses?: boolean;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface CommentUpdateAuthorNameCreateParams {
  /** @format int32 */
  userId?: number;
  name?: string;
  lastName?: string;
}

export interface ExternalApiWithUserDataReviewsListParams {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * @format int32
   * @min 1
   * @max 100
   */
  PageSize?: number;
}

export interface ExternalApiWithUserDataReviewsSortedByEventListParams {
  EventType?: SravniReviewsEnumsExternalApiActivityEventType;

  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * @format int32
   * @min 1
   * @max 100
   */
  PageSize?: number;
}

export interface ExternalApiReviewsListParams {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * @format int32
   * @min 1
   * @max 100
   */
  PageSize?: number;
}

export interface ExternalApiReviewsSortedByEventListParams {
  EventType?: SravniReviewsEnumsExternalApiActivityEventType;

  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * @format int32
   * @min 1
   * @max 100
   */
  PageSize?: number;
}

export interface BackofficeReviewsListParams {
  HaveDocument?: boolean;
  UtmSource?: string;
  UtmCampaign?: string;
  UtmMedium?: string;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
  ModeratorToOrganizationEmail?: string;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  ReviewObjectType?: SravniReviewsEnumsReviewObjectType;
  ReviewObjectTypes?: SravniReviewsEnumsReviewObjectType[];
  ReviewObjectId?: string;
  ReviewObjectIds?: string[];

  /** Тип сортировки отзывов */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Тип фильтрации отзывов */
  FilterBy?: SravniReviewsEnumsReviewFilter;
  Rated?: SravniReviewsEnumsReviewRate[];
  CheckingRated?: SravniReviewsEnumsReviewRate[];
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';
  GroupTag?: 'business' | 'SAD' | 'test' | 'ыфввыф' | '333333333' | '333' | 'Decor' | 'Conditions' | 'bets-variety ';
  GroupedByBanks?: boolean;
  LocationRoute?: string;
  Deleted?: boolean;
  Title?: string;
  Text?: string;
  AuthorName?: string;
  AuthorLastName?: string;
  AuthorEmail?: string;

  /** @format int32 */
  LocationId?: number;

  /** Статусы проверки оценки отзыва */
  RateStatus?: SravniReviewsEnumsReviewRateStatus;
  Ip?: string;
  FingerPrint?: string;
  ReviewOnly?: boolean;
  FollowUpOnly?: boolean;

  /** @format int32 */
  ReviewId?: number;

  /** статус отзыва */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус отзыва */
  CommentReviewStatus?: SravniReviewsEnumsReviewStatus;
  HasCompanyResponse?: boolean;
  SpecificProductId?: string;
  AuthorPhone?: string;
  IsLegal?: boolean;
  IsClient?: boolean;
  HasPersonalData?: boolean;
  NewIds?: boolean;
  ReviewAuthorRoleType?: SravniReviewsEnumsReviewAuthorRoleType;
  ModeratorEmail?: string;
  UniqueOnly?: boolean;
  WithVotes?: boolean;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface ReportsBackofficeReviewsContentListParams {
  HaveDocument?: boolean;
  UtmSource?: string;
  UtmCampaign?: string;
  UtmMedium?: string;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
  ModeratorToOrganizationEmail?: string;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  ReviewObjectType?: SravniReviewsEnumsReviewObjectType;
  ReviewObjectTypes?: SravniReviewsEnumsReviewObjectType[];
  ReviewObjectId?: string;
  ReviewObjectIds?: string[];

  /** Тип сортировки отзывов */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Тип фильтрации отзывов */
  FilterBy?: SravniReviewsEnumsReviewFilter;
  Rated?: SravniReviewsEnumsReviewRate[];
  CheckingRated?: SravniReviewsEnumsReviewRate[];
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';
  GroupTag?: 'business' | 'SAD' | 'test' | 'ыфввыф' | '333333333' | '333' | 'Decor' | 'Conditions' | 'bets-variety ';
  GroupedByBanks?: boolean;
  LocationRoute?: string;
  Deleted?: boolean;
  Title?: string;
  Text?: string;
  AuthorName?: string;
  AuthorLastName?: string;
  AuthorEmail?: string;

  /** @format int32 */
  LocationId?: number;

  /** Статусы проверки оценки отзыва */
  RateStatus?: SravniReviewsEnumsReviewRateStatus;
  Ip?: string;
  FingerPrint?: string;
  ReviewOnly?: boolean;
  FollowUpOnly?: boolean;

  /** @format int32 */
  ReviewId?: number;

  /** статус отзыва */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус отзыва */
  CommentReviewStatus?: SravniReviewsEnumsReviewStatus;
  HasCompanyResponse?: boolean;
  SpecificProductId?: string;
  AuthorPhone?: string;
  IsLegal?: boolean;
  IsClient?: boolean;
  HasPersonalData?: boolean;
  NewIds?: boolean;
  ReviewAuthorRoleType?: SravniReviewsEnumsReviewAuthorRoleType;
  ModeratorEmail?: string;
  UniqueOnly?: boolean;
  WithVotes?: boolean;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

/**
 * @format int32
 */
export type ManageReviewPartialUpdatePayload = number;

/**
 * @format int32
 */
export type ManageCommentPartialUpdatePayload = number;

/**
 * @format int32
 */
export type ManageReviewRequireDocumentsUpdatePayload = number;

/**
 * @format int32
 */
export type ReviewRequireDocumentsUpdatePayload = number;

/**
 * @format int32
 */
export type ManageReviewApproveDocumentsUpdatePayload = number;

/**
 * @format int32
 */
export type ReviewApproveDocumentsUpdatePayload = number;

/**
 * @format int32
 */
export type ManageReviewFollowUpCreatePayload = number;

export interface StatsBusinessListParams {
  ReviewTag?: string;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  OrganizationType?: SravniReviewsEnumsReviewObjectType;
  Interval?: SravniReviewsEnumsDateInterval;

  /** @format int32 */
  IntervalAmount?: number;
  ReviewRates?: number[];
  GroupByOrganizations?: boolean;
  EventTypes?: SravniReviewsEnumsActivityEventType[];
  OrganizationIds?: string[];

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface StatsRatesListParams {
  ReviewTag?: string;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  OrganizationType?: SravniReviewsEnumsReviewObjectType;
  Interval?: SravniReviewsEnumsDateInterval;

  /** @format int32 */
  IntervalAmount?: number;
  ReviewRates?: number[];
  GroupByOrganizations?: boolean;
  EventTypes?: SravniReviewsEnumsActivityEventType[];
  OrganizationIds?: string[];

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface StatsActivityListParams {
  UserIds?: number[];
  EventTypes?: SravniReviewsEnumsActivityEventType[];
  OrganizationIds?: string[];

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface StatsRawReviewListParams {
  OrganizationIds?: string[];
  OrganizationTypes?: SravniReviewsEnumsReviewObjectType[];

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface BackofficeCommentsListParams {
  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  ReviewObjectType?: SravniReviewsEnumsReviewObjectType;
  ReviewObjectTypes?: SravniReviewsEnumsReviewObjectType[];
  ReviewObjectId?: string;
  ReviewObjectIds?: string[];

  /** Тип сортировки отзывов */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Тип фильтрации отзывов */
  FilterBy?: SravniReviewsEnumsReviewFilter;
  Rated?: SravniReviewsEnumsReviewRate[];
  CheckingRated?: SravniReviewsEnumsReviewRate[];
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';
  GroupTag?: 'business' | 'SAD' | 'test' | 'ыфввыф' | '333333333' | '333' | 'Decor' | 'Conditions' | 'bets-variety ';
  GroupedByBanks?: boolean;
  LocationRoute?: string;
  Deleted?: boolean;
  Title?: string;
  Text?: string;
  AuthorName?: string;
  AuthorLastName?: string;
  AuthorEmail?: string;

  /** @format int32 */
  LocationId?: number;

  /** Статусы проверки оценки отзыва */
  RateStatus?: SravniReviewsEnumsReviewRateStatus;
  Ip?: string;
  FingerPrint?: string;
  ReviewOnly?: boolean;
  FollowUpOnly?: boolean;

  /** @format int32 */
  ReviewId?: number;

  /** статус отзыва */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус отзыва */
  CommentReviewStatus?: SravniReviewsEnumsReviewStatus;
  HasCompanyResponse?: boolean;
  SpecificProductId?: string;
  AuthorPhone?: string;
  IsLegal?: boolean;
  IsClient?: boolean;
  HasPersonalData?: boolean;
  NewIds?: boolean;
  ReviewAuthorRoleType?: SravniReviewsEnumsReviewAuthorRoleType;
  ModeratorEmail?: string;
  UniqueOnly?: boolean;
  WithVotes?: boolean;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
  ModeratorToOrganizationEmail?: string;
}

export interface ManageUsersBlocksListParams {
  Term?: string;

  /** @format int32 */
  UserId?: number;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
  Deleted?: boolean;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface ManageUsersBlockCreateParams {
  comment: string;

  /** @format int32 */
  userId: number;
}

export interface ManageTagListParams {
  /** Возвращает тег по подстроке в имени или алисе */
  Term?: string;

  /** Продуктовый заголовок тега */
  Title?: string;

  /** Возвращает теги, соответствующие указанному продуктовому тегу */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';

  /**
   * Возвращает теги определенного отзыва
   * @format int32
   */
  ReviewId?: number;

  /** Возвращает либо позитивные, либо негативные теги. Если null - вернет все. */
  IsPositive?: boolean;

  /** Вернуть только валидные теги, или вместе с удалеными */
  PublicOnly?: boolean;

  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
}

export interface ManageTagProductTagListParams {
  /** наименование тега, ищет по подстроке */
  name?: string;
}

export interface BackofficeRatingListParams {
  RatingName?: string;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  OrganizationType?: SravniReviewsEnumsReviewObjectType;
  OrganizationId?: string;
  ServiceTags?: (
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
  )[];

  /** @format int32 */
  MinReviewsCount?: number;

  /** @format int32 */
  LocationId?: number;

  /** @format int32 */
  FilterId?: number;
  RatingType?: SravniReviewsEnumsRatingType;
  IsLegal?: boolean;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;

  /** @format uuid */
  DraftId?: string;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface ModeratorToOrganizationsDeleteParams {
  /** @format int32 */
  id?: number;
}

export interface DropRedisCacheListParams {
  key?: string;
}

export interface RatingListParams {
  RatingName?: string;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  OrganizationType?: SravniReviewsEnumsReviewObjectType;
  OrganizationId?: string;
  ServiceTags?: (
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
  )[];

  /** @format int32 */
  MinReviewsCount?: number;

  /** @format int32 */
  LocationId?: number;

  /** @format int32 */
  FilterId?: number;
  RatingType?: SravniReviewsEnumsRatingType;
  IsLegal?: boolean;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;

  /** @format uuid */
  DraftId?: string;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface AggregatedRatingListParams {
  RatingName?: string;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  OrganizationType?: SravniReviewsEnumsReviewObjectType;
  OrganizationId?: string;
  ServiceTags?: (
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
  )[];

  /** @format int32 */
  MinReviewsCount?: number;

  /** @format int32 */
  LocationId?: number;

  /** @format int32 */
  FilterId?: number;
  RatingType?: SravniReviewsEnumsRatingType;
  IsLegal?: boolean;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;

  /** @format uuid */
  DraftId?: string;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface ReviewStatsListParams {
  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;
  organizationId?: string;
  reviewTag?: string;
}

export interface ReviewSeoStatsListParams {
  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;
  organizationId?: string;
  reviewTag?: string;
}

export interface RatingStatsListParams {
  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;
  organizationId?: string;
}

export interface SravniCustomersRatingListParams {
  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  OrganizationType?: SravniReviewsEnumsReviewObjectType;
  OrganizationId?: string;

  /** @format date-time */
  OnDate?: string;
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';

  /** @format int32 */
  LocationId?: number;

  /** @format int32 */
  ServicesGroupId?: number;
  RatingType?: SravniReviewsEnumsRatingType;
  IsLegal?: boolean;

  /** @format int32 */
  PageSize?: number;

  /** @format int32 */
  PageIndex?: number;
}

export interface OrganizationUsersListParams {
  OrganizationId?: string;

  /** @format int32 */
  UserId?: number;
  Deleted?: boolean;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface ReputationDetailParams {
  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;
  organizationId: string;
}

export interface ReputationPositionDetailParams {
  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;
  organizationId: string;
}

export interface ReputationStatsDetailParams {
  /** Тип группировки */
  GroupingType?: SravniReviewsEnumsReputationGroupingType;

  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;

  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;
  organizationId: string;
}

export interface ReputationStatsPerformanceOverviewDetailParams {
  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;

  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;
  organizationId: string;
}

export interface ReputationStatsCompanyResponseDetailParams {
  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;

  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;
  organizationId: string;
}

export interface ReputationStatsDetailedDetailParams {
  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;

  /** Тип группировки */
  GroupingType?: SravniReviewsEnumsReputationGroupingType;

  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;

  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
  organizationId: string;
}

export interface ReputationStatsCsvDetailParams {
  /** Список полей для выгрузки, порядок соответствует порядку переданному списку */
  Fields?: SravniReviewsEnumsReputationDetailField[];

  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;

  /** Тип группировки */
  GroupingType?: SravniReviewsEnumsReputationGroupingType;

  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;

  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
  organizationId: string;
}

export interface ReviewsAdditionalInfoSchemesListParams {
  /** Идентификатор организации */
  OrganizationId?: string;

  /** Тип организации */
  OrganizationType?: SravniReviewsEnumsReviewObjectType;

  /** Услуга */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';
  PublicOnly?: boolean;

  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
}

export interface ReviewsAdditionalInfoSchemeListParams {
  /** Тип организации */
  OrganizationType?: SravniReviewsEnumsReviewObjectType;

  /** Идентификатор организации */
  OrganizationId?: string;

  /** Услуга */
  ProductTag?: string;
}

export interface ReviewsListParams {
  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;

  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  ReviewObjectType?: SravniReviewsEnumsReviewObjectType;
  ReviewObjectTypes?: SravniReviewsEnumsReviewObjectType[];
  ReviewObjectId?: string;
  ReviewObjectIds?: string[];

  /** Тип сортировки отзывов */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Тип фильтрации отзывов */
  FilterBy?: SravniReviewsEnumsReviewFilter;
  Rated?: SravniReviewsEnumsReviewRate[];
  CheckingRated?: SravniReviewsEnumsReviewRate[];
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';
  GroupTag?: 'business' | 'SAD' | 'test' | 'ыфввыф' | '333333333' | '333' | 'Decor' | 'Conditions' | 'bets-variety ';
  GroupedByBanks?: boolean;
  LocationRoute?: string;
  Deleted?: boolean;
  Title?: string;
  Text?: string;
  AuthorName?: string;
  AuthorLastName?: string;
  AuthorEmail?: string;

  /** @format int32 */
  LocationId?: number;

  /** Статусы проверки оценки отзыва */
  RateStatus?: SravniReviewsEnumsReviewRateStatus;
  Ip?: string;
  FingerPrint?: string;
  ReviewOnly?: boolean;
  FollowUpOnly?: boolean;

  /** @format int32 */
  ReviewId?: number;

  /** статус отзыва */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус отзыва */
  CommentReviewStatus?: SravniReviewsEnumsReviewStatus;
  HasCompanyResponse?: boolean;
  SpecificProductId?: string;
  AuthorPhone?: string;
  IsLegal?: boolean;
  IsClient?: boolean;
  HasPersonalData?: boolean;
  NewIds?: boolean;
  ReviewAuthorRoleType?: SravniReviewsEnumsReviewAuthorRoleType;
  ModeratorEmail?: string;
  UniqueOnly?: boolean;
  WithVotes?: boolean;
  fingerPrint: string;
}

export interface HeadV2Params {
  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  organizationType?: SravniReviewsEnumsReviewObjectType;
  organizationId?: string;
  reviewTag?: string;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;
}

export interface ReviewsTagsDetailParams {
  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';
  organizationId: string;
}

export interface SettingsFilterDetailParams {
  /** Пользователь физик или юрик. Важно только для банков. */
  isLegal?: boolean;

  /** Тип организации */
  objectType: SravniReviewsEnumsReviewObjectType;
}

export interface ReviewsSeoListParams {
  /** Sravni.Reviews.Enums.ReviewObjectType */
  organizationType?: SravniReviewsEnumsReviewObjectType;
}

export interface ReviewsSeoForSitemapListParams {
  /**
   * Типы объектов для которых можно добавлять комментарии.
   * Важно! Это перечисление хранится в базе, в таблице ReviewObjectType.
   * Поэтому добавляя/изменяя значения синхронизируйте их с базой.
   */
  ReviewObjectType?: SravniReviewsEnumsReviewObjectType;

  /** @format int32 */
  ReviewTag?: number;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface ReviewsCountByOrganizationsListParams {
  /** Sravni.Reviews.Enums.ReviewObjectTypeТип интересующих организаций. Страховые итд */
  reviewObjectType?: SravniReviewsEnumsReviewObjectType;
}

export interface ReviewsAggregatedReviewsCountListParams {
  /** Тип организации */
  OrganizationType?: SravniReviewsEnumsReviewObjectType;

  /** Идентификатор организации */
  OrganizationId?: string;

  /** Код услуги */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';

  /**
   * Идентификатор региона
   * @format int32
   */
  LocationId?: number;
}

export interface TagsListParams {
  /** Возвращает тег по подстроке в имени или алисе */
  Term?: string;

  /** Продуктовый заголовок тега */
  Title?: string;

  /** Возвращает теги, соответствующие указанному продуктовому тегу */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'savings'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'healthInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'leasing'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'other'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'kursy'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'Support'
    | 'Appp'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'Payment'
    | 'Insurance'
    | 'Functional'
    | 'Price'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Education'
    | 'Interface'
    | 'Convenience'
    | 'Duration'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety ';

  /**
   * Возвращает теги определенного отзыва
   * @format int32
   */
  ReviewId?: number;

  /** Возвращает либо позитивные, либо негативные теги. Если null - вернет все. */
  IsPositive?: boolean;

  /** Вернуть только валидные теги, или вместе с удалеными */
  PublicOnly?: boolean;

  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
}

export interface TagProductTagListParams {
  /** наименование тега, ищет по подстроке */
  name?: string;
}

export interface UiComponentsListParams {
  Name?: string;

  /** @format int32 */
  ReviewTag?: number;
  Type?: SravniReviewsEnumsUiComponentType;
  PublicOnly?: boolean;
  ExternalId?: string;

  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
}

export interface ActivityDetailParams {
  ExcludeReviews?: boolean;
  ExcludeComments?: boolean;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;

  /** @format int32 */
  id: number;
}

export interface ActivityByServiceDetailParams {
  ExcludeReviews?: boolean;
  ExcludeComments?: boolean;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;

  /** @format int32 */
  id: number;
}

export interface ViewsReviewsListParams {
  ids?: number[];
}
